// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2pBWQ","title":"AfterBackImages_title__2dFeD","images":"AfterBackImages_images__tPROV"};